<template>
  <div class="container">
    <div>
      <div class="title-bloc">
        <div class="title">
          <h1>Le comte de Minuit</h1>
        </div>
        <div class="subtitle-bloc">
          <div class="subtitle">
            <Chronometer />
          </div>
          <div class="subtitle">
            <h2>💡 {{ hints }}</h2>
          </div>
        </div>
      </div>
      <div class="images">
        <div class="paint-wall">
          <img src="../assets/NewYear/paint1.png" id="paint1" v-on:click="togglePaint()" />
          <img src="../assets/NewYear/paint2.png" id="paint2" v-on:click="togglePaint()" />
        </div>
        <img
          src="../assets/NewYear/Horloge.png"
          id="clock"
          class="elements"
          v-on:click="toggleClock()"
        />
        <img
          src="../assets/NewYear/Imprimante.png"
          id="print"
          class="elements"
          v-on:click="attestation()"
        />
        <img src="../assets/NewYear/Livre.png" id="book" class="elements" v-on:click="toggleBook()" />
        <img
          src="../assets/NewYear/Journal.png"
          id="newspaper"
          class="elements"
          v-on:click="toggleNewspaper()"
        />
        <img
          src="../assets/NewYear/Lettre.png"
          id="letter"
          class="elements"
          v-on:click="toggleIntro()"
        />
        <img
          src="../assets/NewYear/Bloc Note.png"
          id="notes"
          class="elements"
          v-on:click="toggleNote()"
        />
        <img src="../assets/NewYear/background_NY.png" class="ny-img" />
        <transition name="fade">
          <Notes
            class="notes"
            v-if="displayNotes"
            @toggleNote="toggleNote()"
            @update="notesContent = $event"
            :content="notesContent"
          />
          <Victory
            class="victory-modale"
            v-if="victory"
            :startTime="startTime"
            :hints="hints"
            :userName="userName"
            @update="closeModale($event)"
          />
        </transition>
      </div>
    </div>
    <div class="infos">
      <transition name="fade">
        <Intro v-if="displayIntro" />
        <Book
          v-if="displayBook"
          :hintList="hintList"
          @updateHints="hintList = $event"
          @incrementCounter="hints += 1"
        />
        <Newspaper
          v-if="displayNewspaper"
          :hintList="hintList"
          :crosswordLetters="crosswordLetters"
          @updateHints="hintList = $event"
          @incrementCounter="hints += 1"
          @save="crosswordLetters = $event"
        />
        <Paint
          v-if="displayPaint"
          :hintList="hintList"
          @updateHints="hintList = $event"
          @incrementCounter="hints += 1"
        />
        <Clock
          v-if="displayClock"
          :hintList="hintList"
          @update="victory = $event"
          @updateHints="hintList = $event"
          @incrementCounter="hints += 1"
        />
      </transition>
    </div>l
  </div>
</template>

<script>
import Intro from "./NewYear/Intro.vue";
import Notes from "./NewYear/Notes.vue";
import Book from "./NewYear/Book.vue";
import Newspaper from "./NewYear/Newspaper.vue";
import Paint from "./NewYear/Newspaper/Paint.vue";
import Clock from "./NewYear/Clock.vue";
import Victory from "./NewYear/Victory.vue";
import Chronometer from "./shared/Chronometer.vue";
import hintData from "./NewYear/data.js";
import randomName from "../helpers/generateName.js";

export default {
  name: "NewYear",
  components: {
    Intro,
    Notes,
    Book,
    Newspaper,
    Chronometer,
    Paint,
    Clock,
    Victory
  },
  data() {
    return {
      displayIntro: true,
      displayNotes: false,
      displayBook: false,
      displayPaint: false,
      displayNewspaper: false,
      displayClock: false,
      victory: false,
      notesContent: "Prends tes notes ici !",
      startTime: Date.now(),
      hints: 0,
      hintList: hintData,
      userName: randomName,
      crosswordLetters: {}
    };
  },
  methods: {
    closeModale(event) {
      this.victory = event;
      this.toggleIntro();
    },
    toggleClock() {
      this.displayClock = this.displayClock ? false : true;
      this.displayNewspaper = false;
      this.displayIntro = false;
      this.displayBook = false;
      this.displayPaint = false;
    },
    togglePaint() {
      this.displayPaint = this.displayPaint ? false : true;
      this.displayNewspaper = false;
      this.displayIntro = false;
      this.displayBook = false;
      this.displayClock = false;
    },
    toggleNote() {
      this.displayNotes = this.displayNotes ? false : true;
    },
    toggleBook() {
      this.displayBook = this.displayBook ? false : true;
      this.displayNewspaper = false;
      this.displayIntro = false;
      this.displayClock = false;
      this.displayPaint = false;
    },
    toggleIntro() {
      this.displayIntro = this.displayIntro ? false : true;
      this.displayBook = false;
      this.displayNewspaper = false;
      this.displayClock = false;
      this.displayPaint = false;
    },
    toggleNewspaper() {
      this.displayNewspaper = this.displayNewspaper ? false : true;
      this.displayIntro = false;
      this.displayBook = false;
      this.displayClock = false;
      this.displayPaint = false;
    },
    attestation() {
      window.open("https://media.interieur.gouv.fr/deplacement-covid-19", "_blank");
    }
  },
  created() {
    console.log(this.userName);
    this.$http
      .post("https://mystery-engine.herokuapp.com/api/new", {
        game_log: {
          name: this.userName,
          duration: 0,
          enigme: "le-comte-de-minuit",
          status: "started",
          hint: this.hints
        }
      })
      .then(
        function(response) {
          // Success
          console.log("session started", response.data);
        },
        function(response) {
          // Error
          console.log(response.data);
        }
      );
  }
};
window.onbeforeunload = function(e) {
  e = e || window.event;
  if (e) {
    e.returnValue = "Sure?";
  }
  return "Sure?";
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:ital,wght@0,200;0,400;0,600;1,200;1,400;1,600&display=swap");
html {
  margin: 0;
  padding: 0;
  height: 100%;
  max-height: 100%;
}
body {
  margin: 0;
  padding: 0;
  height: 100%;
  max-height: 100%;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.8s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.notes {
  position: absolute;
  z-index: 10;
  left: 5%;
  right: calc(5% + 4mm);
  top: 10%;
  bottom: 30%;
}
.victory-modale {
  position: fixed;
  z-index: 100;
  left: 0;
  top: 0;
}
.container {
  margin: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100vh;
  width: 100vw;
}
.title-bloc {
  height: calc(20vh - 20px);
  margin: 0;
  padding: 10px;
  background: #122130;
  text-align: center;
}
.title {
  font-family: "Permanent Marker", cursive;
  width: 100%;
  font-size: 3vh;
  line-height: 3vh;
  margin: 0;
  text-align: center;
  color: #ebc134;
}
h1 {
  font-family: "Permanent Marker", cursive;
  width: 100%;
  font-size: 5vh;
  line-height: 5vh;
  margin: 0;
  text-align: center;
  color: #ebc134;
}
.subtitle-bloc {
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  text-align: center;
  color: rgb(235, 235, 235);
  font-family: "Permanent Marker", cursive;
  font-size: 2vh;
  line-height: 2vh;
}
.subtitle {
  width: 50%;
}
.ny-img {
  height: 100%;
  cursor: zoom-in;
}
.images {
  height: 80vh;
  position: relative;
}
.infos {
  height: 100vh;
  max-height: 100vh;
  width: 100%;
  background: repeating-linear-gradient(#39434a, #39434a 40px, #122130 40px, #122130 80px);
  border-left: 4mm solid#EBC134;
}
.elements:hover {
  opacity: 0.85;
  cursor: zoom-in;
}
#clock {
  position: absolute;
  height: 24%;
  right: 12%;
  top: 17%;
}
#print {
  position: absolute;
  height: 11%;
  right: 18%;
  top: 40.9%;
}
#book {
  position: absolute;
  height: 7%;
  left: 30%;
  bottom: 5%;
}
#newspaper {
  position: absolute;
  height: 20%;
  right: 10%;
  bottom: 1%;
}
#letter {
  position: absolute;
  height: 7%;
  left: 18%;
  bottom: 39%;
}
#notes {
  position: absolute;
  height: 7%;
  left: 51%;
  bottom: 39%;
}
#paint1 {
  position: absolute;
  left: à;
  width: 100%;
  top: 0%;
}
#paint2 {
  position: absolute;
  left: 0;
  width: 100%;
  bottom: 0%;
}
.paint-wall {
  position: absolute;
  width: 16%;
  height: 25%;
  left: 44%;
  top: 0%;
}
.paint-wall:hover {
  opacity: 0.85;
  cursor: zoom-in;
}
</style>
